import { DemoBackgroundPaths } from '../components/ui/demo';
import { ParkFactsStrip } from '../components/ParkFactsStrip';

export function HomePage() {
  return (
    <>
      <section id="home" className="relative scroll-mt-24">
        <DemoBackgroundPaths />
      </section>
      <ParkFactsStrip />
    </>
  );
}
